import { createTheme } from "@mui/material";

export const useBqaTheme = (lightMode: boolean) => {
  return createTheme({
    palette: {
      mode: lightMode ? "light" : "dark",
      primary: {
        main: lightMode ? "#add3e8" : "#1c00ff",
      },
      secondary: {
        main: lightMode ? "#1c00ff" : "#add3e8",
      },
      background: {
        default: lightMode ? "#f0f0f0" : "black",
      },
    },
    components: {
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              backgroundColor: lightMode ? "#add3e8" : "#0f0570",
            },
          },
        },
      },
    },
  });
};
